import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
interface Report {
  id: number;
  content: string;
  image_url: string | null;
  created_at: string;
}
export function LaporanAdmin() {
  const {
    user,
    isLoading: authLoading
  } = useAuth();
  const [reports, setReports] = useState<Report[]>([]);
  const [loading, setLoading] = useState(true);

  // 🔥 CHECK ADMIN EMAIL
  const isAdmin = user?.email === 'meitasulistiyo@upi.edu';
  useEffect(() => {
    if (!isAdmin) {
      setLoading(false);
      return;
    }
    fetchReports();
  }, [isAdmin]);
  const fetchReports = async () => {
    const {
      data,
      error
    } = await supabase.from('reports').select('*').order('created_at', {
      ascending: false
    });
    if (error) {
      console.error(error);
      setLoading(false);
      return;
    }
    setReports(data || []);
    setLoading(false);
  };

  // ⏳ loading auth
  if (authLoading) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-374">
        <p data-id="element-375">Loading...</p>
      </div>;
  }

  // 🔒 belum login
  if (!user) {
    return <Navigate to="/login" replace data-id="element-376" />;
  }

  // ❌ bukan admin
  if (!isAdmin) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-377">
        <p className="text-red-500 font-semibold" data-id="element-378">
          Akses ditolak (Admin only)
        </p>
      </div>;
  }
  return <div className="min-h-screen bg-pastel-grey-light/30 py-12" data-id="element-379">
      <div className="max-w-4xl mx-auto px-4" data-id="element-380">

        <h1 className="text-3xl font-bold mb-8 text-center" data-id="element-381">
          Dashboard Laporan
        </h1>

        {loading ? <p className="text-center" data-id="element-382">Loading...</p> : reports.length === 0 ? <p className="text-center text-gray-500" data-id="element-383">
            Belum ada laporan masuk
          </p> : <div className="space-y-6" data-id="element-384">
            {reports.map(report => <motion.div key={report.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white rounded-2xl p-5 shadow-md border border-gray-100 hover:shadow-lg transition" data-id="element-385">
                {/* Tanggal */}
                <p className="text-xs text-gray-400 mb-2" data-id="element-386">
                  {new Date(report.created_at).toLocaleString('id-ID')}
                </p>

                {/* Isi laporan */}
                <p className="text-sm text-gray-800 mb-4" data-id="element-387">
                  {report.content}
                </p>

                {/* Gambar (TIDAK KEPOTONG) */}
                {report.image_url && <div className="w-full bg-gray-100 rounded-xl border p-2 cursor-pointer" onClick={() => window.open(report.image_url!, '_blank')} data-id="element-388">
                    <img src={report.image_url} alt="Bukti laporan" className="w-full max-h-[300px] object-contain rounded-lg" data-id="element-389" />
                  </div>}
              </motion.div>)}
          </div>}
      </div>
    </div>;
}